var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFacilityDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFFAE8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 38.625,
    width: 2.5,
    height: 5,
    fill: "#FFD058"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 39.25,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.375,
    y: 38.625,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.625,
    y: 32.375,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.375,
    y: 27.375,
    width: 2.5,
    height: 1.25,
    fill: "#FFD058"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 31.125,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.375,
    y: 27.375,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27.375,
    y: 23.625,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 23.625,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 19.875,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 27.375,
    y: 19.875,
    width: 1.25,
    height: 1.25,
    fill: "#FFD058"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27.375,
    y: 14.875,
    width: 5.625,
    height: 2.5,
    fill: "#FFD058"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 29.875H18V31.125L16.125 32.375V29.875Z",
    fill: "#FFD058"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.75,
    cy: 33,
    r: 1.25,
    fill: "#FFD058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 12.375V14.5625H33.3125V17.0625H35.8125V24.5625H42.0625V29.5625H41.4375V25.1875H35.8125V43.3125H41.4375V30.8125H42.0625V43.3125H43.9375V43.9375H42.0625H41.4375H35.8125H35.1875H33.5469V43.3125H35.1875V25.1875V24.5625V17.6875H33.3125H32.6875H27.6875H27.0625H25.1875V20.9688H24.5625V17.0625H27.0625V14.5625H29.875V12.375H30.5ZM27.6875 15.1875H29.875H30.5H32.6875V17.0625H27.6875V15.1875ZM25.1875 21.9844V23H24.5625V21.9844H25.1875ZM25.1875 23.625V30.5413L31.2981 34.615L31.1248 35.1875H29.2498V43.3125H32.0625V43.9375H29.2498V43.9375H14.2498V43.9375H12.0625V43.3125H14.2498V39.25H14.8748V43.3125H19.875V38H23.625V43.3125H28.6248V34.5625H30.0926L21.7559 29.0047L13.9749 34.5625H14.8748V38H14.2498V35.1875H12.9998L12.8181 34.6207L15.8125 32.4819V29.25H18.3125V30.6962L21.7436 28.2454L24.5625 30.1246V23.625H25.1875ZM17.6875 31.1426V29.875H16.4375V32.0355L17.6875 31.1426ZM23 38.625V43.3125H20.5V38.625H23ZM23 33C23 33.6904 22.4404 34.25 21.75 34.25C21.0596 34.25 20.5 33.6904 20.5 33C20.5 32.3096 21.0596 31.75 21.75 31.75C22.4404 31.75 23 32.3096 23 33ZM23.625 33C23.625 34.0355 22.7855 34.875 21.75 34.875C20.7145 34.875 19.875 34.0355 19.875 33C19.875 31.9645 20.7145 31.125 21.75 31.125C22.7855 31.125 23.625 31.9645 23.625 33ZM27.375 19.875H28.625V21.125H27.375V19.875ZM26.75 21.75V19.25H29.25V21.75H26.75ZM28.625 23.625H27.375V24.875H28.625V23.625ZM26.75 23V25.5H29.25V23H26.75ZM31.75 23.625H33V24.875H31.75V23.625ZM31.125 25.5V23H33.625V25.5H31.125ZM33 19.875H31.75V21.125H33V19.875ZM31.125 19.25V21.75H33.625V19.25H31.125ZM27.375 27.375H28.625V28.625H27.375V27.375ZM26.75 29.25V26.75H29.25V29.25H26.75ZM33 31.125H31.75V32.375H33V31.125ZM31.125 30.5V33H33.625V30.5H31.125ZM37.375 27.375H39.875V28.625H37.375V27.375ZM36.75 29.25V26.75H40.5V29.25H36.75ZM39.875 32.375H38.625V33.625H39.875V32.375ZM38 31.75V34.25H40.5V31.75H38ZM33 39.25H31.75V40.5H33V39.25ZM31.125 38.625V41.125H33.625V38.625H31.125ZM36.75 40.5V38H39.25V40.5H36.75ZM37.375 39.875V38.625H38.625V39.875H37.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacilityDetails);
export default __webpack_public_path__ + "static/media/logo-facility-details.b52871a1d7fa2d47c85d40db98e236be.svg";
export { ForwardRef as ReactComponent };